export default __webpack_public_path__ + "assets/02d.55422f88.svg";